import React from 'react';

import styles from 'molecules/Link/link.module.scss';

import parseUrl from 'utils/parseUrl';

import type { LinkHTMLAttributes } from 'react';

export interface LinkProps extends LinkHTMLAttributes<HTMLAnchorElement> {
  href: string;
  variant?: 'unstyled' | 'inline';
  target?: string;
}

export const Link = ({ className, variant = 'unstyled', href, target, ...props }: LinkProps) => {
  const { as: Component, ...parsedUrl } = parseUrl(href);
  const asDiv = Component === 'div';

  const variantClass = asDiv ? 'unstyled' : variant;
  const asDivClass = asDiv ? 'asDiv' : '';

  const combinedClassName = `${styles.link} ${styles[variantClass]} ${styles[asDivClass]} ${className || ''}`;

  return (
    <Component className={combinedClassName} {...parsedUrl} target={target || parsedUrl.target} {...props}>
      {props.children}
    </Component>
  );
};

export default Link;
